import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { getLoggedInUser } from "./AuthenticationService";

export async function messageSubmit(message) {
  const userId = await getLoggedInUser();
  let url = getApiUrl() + "/users/" + userId._id + "/message";
  return fetch(url, {
    method: "POST",
    headers: await getHeaderForAjax(),
    body: JSON.stringify(message),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function getMessages(userID) {
  //{{server_url}}/users/{{user}}/daily_report/?start=1632256200000&participant=04200000273
  const user = await getLoggedInUser();
  let url = getApiUrl() + "/users/" + user._id + "/message";
  let method = "GET";
  return fetch(url, {
    method: method,
    headers: await getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export async function deleteConversation(conversationId) {
  //{{server_url}}/users/{{user}}/daily_report/?start=1632256200000&participant=04200000273
  const user = await getLoggedInUser();
  let url = getApiUrl() + "/users/" + user._id + "/message/" + conversationId;
  let method = "DELETE";
  return fetch(url, {
    method: method,
    headers: await getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function publishDraft(draftId) {
  ////{{server_url}}/users/04200000818/message/6220801ffcfd1d25f86dba87/publish
  const user = await getLoggedInUser();
  let url =
    getApiUrl() + "/users/" + user._id + "/message/" + draftId + "/publish";
  let method = "PUT";
  return fetch(url, {
    method,
    headers: await getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function messageUpdateService(message) {
  const userId = await getLoggedInUser();
  let url = getApiUrl() + "/users/" + userId._id + "/message/" + message._id;
  return fetch(url, {
    method: "PUT",
    headers: await getHeaderForAjax(),
    body: JSON.stringify(message),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function recalcUnits(upc, payload) {
  // Sample API: {{server_url}}/users/{{user}}/upc/9555021512892/recalculate
  const userId = await getLoggedInUser();
  let url = getApiUrl() + "/users/" + userId._id + "/upc/" + upc + "/recalculate";
  return fetch(url, {
    method: "POST",
    headers: await getHeaderForAjax(),
    body: JSON.stringify(payload),
  })
    .then(checkStatus)
    .then((res) => res.text())
    .then((text) => {
      if (!text) return { ok: true };
      try { return JSON.parse(text); }
      catch (e) { return { ok: true, raw: text }; }
    });
}



// WEBPACK FOOTER //
// ./src/services/MessageService.js